import { Injectable, InjectionToken } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export const HTTP_CLIENT = new InjectionToken<HttpClient>('HTTP_CLIENT');

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    // replay subject for triggering the logout
    logoutSource = new ReplaySubject<boolean>();

    // observable that the console will subscribe to in order to determine when to logout
    logout = this.logoutSource.asObservable();

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    public getAccessToken() {
        const accessToken = this.getAccessTokenValue();
        const expired = this.isExpired();
        return { accessToken, expired };
    }

    private getAccessTokenValue(): string | undefined {
        const stored = localStorage.getItem('access_token');
        if (stored) {
            return stored;
        }

        // Fallback to Auth0 SPA SDK cache entry (if present).
        // The SDK also stores a '@@user@@' entry under the same prefix that has no
        // access token, so scan all matching entries for one that carries a token.
        try {
            for (const [key, value] of Object.entries(localStorage)) {
                if (!key.startsWith('@@auth0spajs@@') || key.includes('@@user@@') || !value) {
                    continue;
                }
                const token = JSON.parse(value)?.body?.access_token;
                if (typeof token === 'string') {
                    return token;
                }
            }
            return undefined;
        } catch {
            return undefined;
        }
    }

    private isExpired(): boolean {
        const raw = localStorage.getItem('expires_at');
        if (!raw) {
            return false;
        }
        try {
            const expiresAt = JSON.parse(raw);
            if (typeof expiresAt !== 'number') {
                return false;
            }
            return Date.now() >= expiresAt;
        } catch {
            return false;
        }
    }
}
